// Livelli di scadenza condizioni economiche: badge + testo + colore (mai solo colore).
export function expiryInfo(dateStr) {
  if (!dateStr) return { days: null, level: "none", label: "—", tone: "neutral" };
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const d = new Date(dateStr);
  d.setHours(0, 0, 0, 0);
  const days = Math.round((d - today) / 86400000);
  if (days < 0) return { days, level: "SCADUTO", label: "Scaduto", tone: "danger" };
  if (days <= 30) return { days, level: "URGENTE", label: "Urgente", tone: "danger" };
  if (days <= 60) return { days, level: "ATTENZIONE", label: "Attenzione", tone: "warning" };
  if (days <= 90) return { days, level: "DA_CONTATTARE", label: "Da contattare", tone: "warning" };
  if (days <= 120) return { days, level: "DA_MONITORARE", label: "Da monitorare", tone: "info" };
  return { days, level: "OK", label: "Regolare", tone: "success" };
}

export function daysLabel(days) {
  if (days == null) return "—";
  if (days < 0) return `Scaduto da ${Math.abs(days)} gg`;
  if (days === 0) return "Scade oggi";
  return `${days} gg`;
}

export const PRICE_TYPES = ["Fisso", "Variabile", "Altro"];
export const CONTRACT_STATUS = ["Bozza", "Inserito", "In lavorazione", "Attivo", "Rinnovato", "Cessato", "Annullato"];
export const SUPPLY_STATUS = ["Attiva", "In lavorazione", "Cessata", "Rinnovata"];

export function contractStatusTone(status) {
  switch (status) {
    case "Attivo": return "success";
    case "Rinnovato": return "info";
    case "Cessato":
    case "Annullato": return "danger";
    case "In lavorazione":
    case "Inserito": return "warning";
    default: return "neutral";
  }
}
